<h3>Plano de uso</h3>
<div class="row">
  <div class="col-md-7">
    <div class="card card-blue">
      <div class="card-body">
        Usuários<div>1 de 1 contratados</div>
        <div class="progress mb-3">
          <div class="progress-bar bg-info" role="progressbar" aria-valuenow="1" aria-valuemin="0" aria-valuemax="1" style="width: 100%">

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
